import { geofenceInitialState } from "./geofence/initial-state";
import { rmBuddiesInitialState } from "./rm-buddies/initital-state";

export const initialState = {
  geofence: geofenceInitialState,
  rmBuddies: rmBuddiesInitialState
};
